import { makeAutoObservable } from 'mobx'
import { getDescendants } from '@minoru/react-dnd-treeview'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { TreeRootInboxes } from 'entities/Inbox'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'
import { searchFilter } from 'pages/conversations/ui/ConversationMenu/lib/searchFilter'

export class FavoritesMenuStore {
  private _search = ''

  constructor(
    private _conversationMenuStore: ConversationMenuStore,
    private _entities: IEntitiesStore
  ) {
    makeAutoObservable(this)
  }

  handleUpdateSearch = (value: string) => {
    this._search = value
  }

  private get _selectInboxesFavoriteFreeFilter() {
    if (!this._search) return this._conversationMenuStore.selectInboxesFreeSort

    return this._conversationMenuStore.selectInboxesFreeSort.filter((inboxTree) => {
      return searchFilter(inboxTree.data, this._search, this._entities)
    })
  }

  get items() {
    return getDescendants(this._selectInboxesFavoriteFreeFilter, TreeRootInboxes.FAVORITE)
  }

  get search() {
    return this._search
  }

  get hideInboxes() {
    return this.items.length === 0 && this.search === ''
  }

  private get _selectInboxesFilter() {
    return this._entities.inboxesStore.personalInboxes
  }

  private get _selectInboxes() {
    return this._selectInboxesFilter.filter((item) => item.isFavoriteType)
  }

  get selectInboxesCount() {
    return this._selectInboxes.map((item) => item.unread).reduce((state, value) => state + value, 0)
  }
}
